import { render, staticRenderFns } from "./NutirtionDrawer.vue?vue&type=template&id=69f40545&scoped=true"
import script from "./NutirtionDrawer.vue?vue&type=script&lang=js"
export * from "./NutirtionDrawer.vue?vue&type=script&lang=js"
import style0 from "./NutirtionDrawer.vue?vue&type=style&index=0&id=69f40545&prod&lang=scss&scoped=true"
import style1 from "./NutirtionDrawer.vue?vue&type=style&index=1&id=69f40545&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f40545",
  null
  
)

export default component.exports